/* eslint-disable no-plusplus */ // putting this at the top level to bypass eslint error: 'unary operator '++' used'
/**
 * Table of Contents Plugin
 * Author Name: Consultwebs
 * Description: This is a plugin to use in our current framework
 * To exclude a heading, add a class "toc-exclude" to the heading tag
 */
class CwTableOfContents {

    constructor(acf_col_vars) {
        this.regexPunctuations = /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g;
        this.regexInnerText = /(<([^>]+)>)/gi;
        this.regexLineBreaks = /\r?\n|\r/g;
        this.headers = document.querySelectorAll('h2'); //h2, h3, h4, h5, h6
        this.headingLevel = 1;
        this.typeTag = '';
        this.type = acf_col_vars.type_list;
        this.column = acf_col_vars.column_layout;
        this.width = acf_col_vars.width;
        this.viewport = acf_col_vars.viewport;
        this.activate = acf_col_vars.activate;
        this.breakpoint = '';
        this.screenSize = window.matchMedia(`(min-width: ${this.viewport}px)`);
    }

    createTOC() {

        if (this.type === 'Ordered List') {
            this.typeTag = 'ol';
        } else {
            this.typeTag = 'ul';
        }

        let containerListType = '';

        /* searches content area for heading tags and creates the toc list */
        this.headers.forEach(heading => {
            if(heading.closest('.pegasaas-mega-menu-item')) {
                heading.classList.add('toc-exclude');
            }
            if (!heading.classList.contains("toc-exclude")) { // check if heading does not contain class "toc-exclude"
                const text = heading.textContent;
                let level = heading.tagName.slice(-1);

                let anchorHash = text.toLowerCase()
                    .trim()
                    .replace(this.regexInnerText, "")
                    .replace(this.regexPunctuations, "")
                    .replace(this.regexLineBreaks, "")
                    .replace(/ /g, "-");

                heading.id = anchorHash;

                // hierarchical ordered list
                if (level > this.headingLevel) {
                    containerListType += (new Array(level - this.headingLevel + 1)).join(`<${this.typeTag}>`);
                } else if (level < this.headingLevel) {
                    containerListType += (new Array(this.headingLevel - level + 1)).join(`</li></${this.typeTag}>`);
                } else {
                    containerListType += (new Array((this.headingLevel) + 1)).join('</li>');
                }

                this.headingLevel = parseInt(level, 10);

                // clean innerLinkNode anchors of punctuation marks and create hrefs based on heading text
                this.anchor = text.replace(this.regexInnerText, "");
                this.anchor = this.anchor.replace(this.regexPunctuations, "");

                // this.anchor = this.anchor.replace(/<[^>]+>/g, '');
                this.anchor = this.anchor.replace(/ /g, "_");
                this.innerLinkNode = `<a href="#${anchorHash}">${text}</a>`;
                containerListType += `<li>${this.innerLinkNode}`;
            }
        });
        /* end create toc list */

        if (this.headingLevel) {
            containerListType += (new Array(this.headingLevel + 1)).join(`</${this.typeTag}>`);
        }

        // assign breakpoint for bootstrap class
        if (this.viewport == '768') {
            this.breakpoint = 'md';
        } else if (this.viewport == '992') {
            this.breakpoint = 'lg';
        } else if (this.viewport == '1200') {
            this.breakpoint = 'xl';
        }

        //console.log("Breakpoint" + this.breakpoint);

        function detectWidgetMedia(e, containerListType, breakpoint) {
            /* start widget code */

            if (e.matches) { // if screen/device size is equal or more than breakpoint
                console.log('desktop');
                if (containerListType.length != 0 && !(document.querySelector('.sidebar-toc'))) { // check if toc list is not empty

                    // creates child sidebar item for sidebar
                    const sidebarItem = document.createElement('div');
                    sidebarItem.setAttribute('class', `sidebar-item sidebar-toc d-none d-${breakpoint}-block`);

                    const tocWidget = document.createElement('div');
                    tocWidget.setAttribute('class', 'toc')
                    tocWidget.setAttribute('id', 'toc');
                    tocWidget.innerHTML = `<div class="sidebar-title text-center">Table of Contents</div>${containerListType}`;

                    sidebarItem.appendChild(tocWidget);
                    console.log("Desktop" + sidebarItem);

                    var sidebar = document.querySelector('.main-content .sidebar');
                    sidebar.insertBefore(sidebarItem, sidebar.childNodes[0]);
                }

            } else { // if screen/device size is lesser than viewport width
                console.log('mobile');
                if (containerListType.length != 0 && !(document.querySelector('.sidebar-toc-mobile'))) { // check if toc list is not empty
                    // creation of sidebar item
                    const sidebarItem = document.createElement('div');
                    sidebarItem.setAttribute('class', `sidebar-item sidebar-toc-mobile d-block d-${breakpoint}-none`);

                    const tocWidget = document.createElement('div');
                    tocWidget.setAttribute('class', 'float-lg-start toc sidebar-widget')
                    tocWidget.setAttribute('id', 'toc');
                    tocWidget.innerHTML = `<div class="sidebar-title text-center">Table of Contents</div>${containerListType}`;

                    sidebarItem.appendChild(tocWidget);
                    console.log(sidebarItem);

                    var sidebarMobile = document.querySelector('.main-content .mobile-toc-widget-container');
                    sidebarMobile.insertBefore(sidebarItem, sidebarMobile.childNodes[0]);
                }
            } /* end widget code */
        }

        if (this.activate) {
            detectWidgetMedia(this.screenSize, containerListType, this.breakpoint);

            // listens to changes (ie orientationChange, screen resize)
            this.screenSize.addEventListener("change", () => {
                detectWidgetMedia(this.screenSize, containerListType, this.breakpoint);
            });
        }

        function detectShortCode(e, containerListType) {

            if (document.querySelector('.toc-shortcode')) {
                if (containerListType.length != 0) { // check if toc list is not empty
                    console.log('toc shortcode');

                    const shortcodeContainerTOC = document.querySelector('.toc-shortcode');

                    const tocShortcode = document.createElement('div');
                    tocShortcode.setAttribute('class', 'float-lg-start toc sidebar-widget')
                    tocShortcode.setAttribute('id', 'toc');
                    tocShortcode.innerHTML = `<div class="sidebar-title text-center">Table of Contents</div>${containerListType}`;

                    console.log('tocShortcode' + tocShortcode);
                    shortcodeContainerTOC.insertBefore(tocShortcode, shortcodeContainerTOC.childNodes[0]);
                }
            }
        }

        if (document.querySelector('.toc-shortcode')) {
            detectShortCode(this.screenSize, containerListType);
        }


        // remove appended hash in the url for every clicked linkTag in TOC
        window.addEventListener("hashchange", () => {
            window.history.pushState("", document.title, window.location.pathname);
        });
    }

    columnLayout() {

        if (this.type === 'Ordered List') {
            this.typeTag = 'ol';
        } else {
            this.typeTag = 'ul';
        }

        // changes toc width according to radio button value in site options
        function detectMedia2(e, tocColumn, containerList) {
            if (containerList) {
                if (e.matches) { // if screen/device size is equal or more than 1200px

                    // divides the ordered containerList into two columns'
                    if (tocColumn === '2 Columns') {
                        containerList.setAttribute("style", "column-count:2; column-gap:25px");
                    }

                } else { // if screen/device size is lesser than 1200px
                    containerList.setAttribute("style", "column-count:1");
                }
            }
        }
        if (document.querySelector('.toc-shortcode')) {
            this.containerList = document.querySelector(`.toc ${this.typeTag}`);
            // initial call of function
            detectMedia2(this.screenSize, this.column, this.containerList);

            // listens to changes (ie orientationChange, screen resize)
            this.screenSize.addEventListener("change", () => {
                detectMedia2(this.screenSize, this.column, this.containerList);
            });

        }
    }

    tocWidth() {

        // changes toc width according to radio button value in site options
        function detectMedia3(e, tocwidth) {
            if (e.matches) { // if screen/device size is equal or more than 1200px
                if (tocwidth === 'One Third') {
                    document.querySelector('.toc').style.width = '345px';
                    document.querySelector('.toc').style.float = 'left';
                } else if (tocwidth === 'Full Width') {
                    document.querySelector('.toc').style.width = '100%';
                    document.querySelector('.toc').style.float = 'none';
                }
            } else { // if screen/device size is lesser than 1200px
                document.querySelector('.toc').style.width = 'inherit';
                document.querySelector('.toc').style.float = 'none';
            }
        }
        if (document.querySelector('.toc-shortcode')) {
            // initial call of function
            detectMedia3(this.screenSize, this.width);

            // listens to changes (ie orientationChange, screen resize)
            this.screenSize.addEventListener("change", () => {
                detectMedia3(this.screenSize, this.width);
            });
        }

    }
}

export default CwTableOfContents;